export const GET_WHATSAPP_DEVICE_TOKEN  = 'GET_WHATSAPP_DEVICE_TOKEN';
export const GET_WHATSAPP_CUSTOMER  = 'GET_WHATSAPP_CUSTOMER';
export const DISCONNECT_WHATSAPP_DEVICE_TOKEN  = 'DISCONNECT_WHATSAPP_DEVICE_TOKEN';
export const WHATSAPP_DEVICE_TOKEN_REQUEST  = 'WHATSAPP_DEVICE_TOKEN_REQUEST';
export const WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE  = 'WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE';